const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/communities/$communityId/manage/settings/welcome_message.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
export const Route = createFileRoute("/_authenticated/_feature_announcement/communities/$communityId/manage/settings/welcome_message")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Welcome Message",
      description: "Page title for welcome message settings tab"
    })
  }
});